function MFRFilters(index, element, hasLoadmore) {
  this.$element = $(element)
  this.hasLoadmore = hasLoadmore

  this.selectors = {
    slider: ".slider",
    gridContainer: ".section-grid",
    gridItem: ".blog-item",
    filterContainer: ".section-filter-container",
    filterButtonsContainer: ".filter-button-group",
    buttonsContainer: ".section-buttons",
    discountBubble: ".discount-bubble",
    loadMorePostsButton: "#load-more-posts"
  }

  this.states = {
    filters: {}
  }

  this.init()
}

MFRFilters.prototype = Object.assign({}, MFRFilters.prototype, {
  init: function () {
    this.$slider = this.$element.find(this.selectors.slider)
    this.$gridContainer = this.$element.find(this.selectors.gridContainer)
    this.$gridItem = this.$element.find(this.selectors.gridItem)
    this.$filterContainer = this.$element.find(this.selectors.filterContainer)
    this.$filterButtonsContainer = this.$element.find(this.selectors.filterButtonsContainer)
    this.$buttonsContainer = this.$element.find(this.selectors.buttonsContainer)
    this.$discountBubble = this.$element.find(this.selectors.discountBubble)
    this.$loadMorePostsButton = this.$element.find(this.selectors.loadMorePostsButton)

    $(window).on("load", this.__handleInitialization.bind(this))
    $(window).on("resize", this.__handleInitialization.bind(this))

    this.$filterContainer.on("click", ".filter-item", this.__handleGridFilter.bind(this))
  },

  __handleInitialization: function() {
    this.__handleIsotopeInitialization()
    this.__handleGridItemHeight()
    this.__handleButtonGroupActiveState()
    this.__handleSectionButtonsVisibility()
    this.__handleGridItemImageSlider()

    if (this.hasLoadmore) {
      this.__handleLoadMorePosts()
    }
  },

  __handleGridItemImageSlider: function() {
    setTimeout(() => {
      this.$slider.flickity({
        pageDots: false,
        selectedAttraction: 0.2,
        friction: 0.8,
        wrapAround: true
      })

      window.flickityButtonArrowChange()

      this.$slider.find('.flickity-slider').each(function() {
        if ($(this).children().length <= 1) {
          $(this).parents('.card-images').children('.flickity-button').addClass('hidden')
        }
      })
    }, 1500)
  },

  __handleIsotopeInitialization: function() {
    this.$gridContainer.isotope({ itemSelector: this.selectors.gridItem })

    setTimeout(() => {
      this.$gridContainer.isotope('layout')
    }, 3000)
  },

  __handleGridFilter: function(event) {
    const $button = $(event.currentTarget)
    const $buttonGroup = $button.parents(this.selectors.filterButtonsContainer)
    const filterGroup = $buttonGroup.attr('data-filter-group')

    this.states.filters[filterGroup] = $button.attr('data-filter')

    let filterValue = this.__handleConcatValues(this.states.filters)
    this.$gridContainer.isotope({ filter: filterValue })
    this.__handleUpdateFilterCounts()
  },

  __handleButtonGroupActiveState: function(event) {
    this.$filterButtonsContainer.each((index, buttonGroup) => {
      const $buttonGroup = $(buttonGroup)
  
      $buttonGroup.on('click', 'button', (event) => {
        $buttonGroup.find('.is-selected').removeClass('is-selected')
        $(event.currentTarget).addClass('is-selected')
      })
    })
  },

  __handleSectionButtonsVisibility: function() {
    if ( this.$buttonsContainer.children().length === 0 ) {
      this.$buttonsContainer.hide()
    }
  },

  __handleGridItemHeight: function() {
    if ( matchMedia('screen and (min-width: 1024px)').matches ) {
      const highestContenteHeight = this.__handleGetHighestElementHeight(this.$gridItem.find('.content'))
      this.$gridItem.find('.content').height(highestContenteHeight)
    }
  },

  __handleGetHighestElementHeight: function(elements) {
    let highestHeight = 0

    elements.each(function() {
      const height = $(this).height()
      if (height > highestHeight) {
        highestHeight = height
      }
    })
  
    return highestHeight;
  },

	__handleConcatValues: function(obj) {
		let value = ''
		for ( let prop in obj ) {
			value += obj[ prop ]
		}
		return value
	},

	__handleUpdateFilterCounts: function() {
		const countItems = this.$gridContainer.isotope('getFilteredItemElements').length
		const $noResults = '<div class="no-results"><h6>No results found.</h6><p><button data-open="upgraded-amenities">See Upgraded Amenities</button></p></div>'

		AOS.refresh()
		$(".no-results").remove()

		if (countItems === 0) {
			this.$gridContainer.prepend($noResults)
      this.$gridContainer.addClass('height-auto')
			this.$discountBubble.addClass('margin-top')
		} else {
			this.$discountBubble.removeClass('margin-top')
      this.$gridContainer.removeClass('height-auto')
		}

    this.__handleLoadMorePostsVisibility(true)
		this.$gridContainer.isotope('layout')
	},

  __handleLoadMorePosts: function(e) {
    const itemsToShow = 6
    const itemsToLoad = 6
    const $items = this.$gridItem

    $items.slice(itemsToShow).hide()

    this.$loadMorePostsButton.click(function() {
      let $hidden = $items.filter(':hidden')
      
      if ($hidden.length > 0) {
        $hidden.slice(0, itemsToLoad).slideDown()
      }

      if ($items.filter(':hidden').length === 0) {
        $(this).hide()
      }
    })

    this.$gridContainer.isotope('layout')
  },

  __handleLoadMorePostsVisibility: function(e) {
    if (e) {
      this.$loadMorePostsButton.hide()
    }
  }
})